import { fieldValue } from './fields';
import { getNormalizedStatusKey } from '../../../../utils/statusMapping';

/** Normalized pipeline key for a raw lead row — same mapping the whole platform uses. */
export const normalizeLeadStatus = (v: unknown): string => getNormalizedStatusKey(fieldValue(v));
